module.exports = __webpack_public_path__ + "img/methodical-organiser.fab23828.svg";